document.addEventListener('click', function (e) {
    if (!e.target.closest('#btnEliminarConsumidoDesdEditar')) return;

    const idConsumido = document.getElementById('idLineaEntregaPaquetesConsumidosEditar').value;
    const idReporte   = document.getElementById('idReporteSopladoEditarConsumido').value;

    const inputIdEliminar      = document.getElementById('idLineaEntregaPaquetesConsumidosEliminar');
    const inputReporteEliminar = document.getElementById('idReporteSopladoEliminarConsumido');

    if (inputIdEliminar)      inputIdEliminar.value      = idConsumido ?? '';
    if (inputReporteEliminar) inputReporteEliminar.value = idReporte   ?? '';
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formEliminarConsumidoSoplado');
    if (!form) return;
    e.preventDefault();

    modal = form.closest('.modal');
    modalEditar = document.getElementById('modalEditarConsumidoSoplado');

    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/eliminar-entrega-consumido', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(r => r.json())
    .then(json => {
        const resultado = json.result ?? '';
        const errores = resultado.errores ?? [];
        errores.forEach(e => {
            lanzarAlerta(e.mensaje, e.clase);
            const campo = form.querySelector('[name="' + e.campo + '"]');
            if (campo) campo.classList.add('inputRojo');
        });

        if (!resultado.hayErrores) {
            const idReporte = document.getElementById('idReporteSopladoEliminarConsumido').value;
            form.reset();
            modal.classList.remove('modal--show');

            if (modalEditar) modalEditar.classList.remove('modal--show');

            if (idReporte && typeof window.actualizarTablaConsumido === 'function') {
                window.actualizarTablaConsumido(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            lanzarAlerta('Paquete consumido eliminado correctamente.', 'alerta-verde');
        }
    })
    .catch(() => lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'))
    .finally(() => { if (btnSubmit) btnSubmit.disabled = false; });
});
